import withStyles from '@material-ui/core/styles/withStyles'

export default withStyles(theme => {
  return {
    items: {
      marginTop: 24,
    },
    link: {
      display: 'flex',
      alignItems: 'center',
      fontSize: 16,
      fontWeight: 'bold',
      lineHeight: 1.25,
      color: '#8866ff',
      marginTop: 10,
      marginBottom: 24,
    },
    '@keyframes scale': {
      '0': {
        transform: 'scale(1.01)',
      },
      '50%': {
        transform: 'scale(1.02)',
      },
      '100%': {
        transform: 'scale(1.)',
      },
    },
  }
})
